import clsx from 'clsx'

const Hero = ({ title, imageUrl, size = 'large', children }) => {
    const containerClass = clsx(
        'relative w-full overflow-hidden flex flex-col items-center justify-center text-center',
        'bg-center bg-cover',
        {
            'aspect-[4/3] md:aspect-[19/6]': size === 'large',
            'aspect-[4/3] md:aspect-[16/9]': size === 'medium',
        }
    )

    return (
        <div className={containerClass}>
            {/* Background image layer */}
            <img
                src={imageUrl}
                alt={title}
                className='absolute inset-0 object-cover w-full h-full'
            />

            {/* Dark overlay */}
            <div className='absolute inset-0 z-0 bg-black/50' />

            {/* Content */}
            <div className='relative z-10 flex flex-col items-center justify-center w-full h-full px-4'>
                <h1 className='max-w-screen-md text-2xl font-bold text-white sm:text-3xl md:text-5xl'>
                    {title}
                </h1>

                {children && <div className='w-full max-w-screen-sm mt-4'>{children}</div>}
            </div>
        </div>
    )
}

export default Hero
